const SCDoubleReportCtrl = ['$scope', '$window', 'SUPPLY_RATES', 'ConsumptionReportService',
    function ($scope, $window, SUPPLY_RATES, ConsumptionReportService) {
        var self = this;

        $scope.status = 'WAITING';
        $scope.highlightQty = 0;
        $scope.rate = '';
        $scope.availableRates = SUPPLY_RATES;
        $scope.reportData = {};
        $scope.empty = true;

        $scope.generateReport = function () {
            $scope.status = 'LOADING';
            ConsumptionReportService.getConsumptionDoubleReport(self.getQueryParams())
                .then(function (data) {
                var reportData = {};
                $scope.empty = true;
                for (var i = 0; i < data.length; i++) {
                    var day_of_week = data[i].data;
                    for (var j = 0; j < day_of_week.length; j++) {
                        var cellData = day_of_week[j];
                        if (typeof reportData[cellData.time] === 'undefined') {
                            reportData[cellData.time] = [
                                {time: cellData.time, value: cellData.time, viewValue: cellData.time}
                            ];
                        }
                        if (false == isNaN(cellData.value)) {
                            var viewValue = (Math.round(cellData.value * 100) / 100);
                            if (cellData.value > 0)
                                cellData.viewValue = '+' + viewValue + '%';
                            else
                                cellData.viewValue = viewValue + '%';
                            cellData.highlight = false;
                        } else {
                            cellData.viewValue = cellData.value;
                            cellData.highlight = true;
                        }
                        $scope.empty = false;
                        reportData[cellData.time].push(cellData);
                    }
                }
                $scope.reportData = reportData;
                $scope.status = 'LOADED';
            }).catch(function (error) {
                // TODO: better error control
                $scope.status = 'ERROR';
            });
        };

        $scope.downloadCSV = function () {
            var url = API_URL + '/consumptions/double-report/' + self.getQueryParams();
            $window.open(url);
        };

        this.transformToRESTyDate = function (date) {
            var yyyy = date.getFullYear().toString();
            var mm = (date.getMonth() + 1).toString(); // getMonth() is zero-based
            var dd = date.getDate().toString();
            return yyyy + '-' + (mm[1] ? mm : "0" + mm[0]) + '-' + (dd[1] ? dd : "0" + dd[0]); // padding
        };

        this.getQueryParams = function () {
            if ($scope.fromDateOne > $scope.toDateOne) {
                var aux = $scope.fromDateOne;
                $scope.fromDateOne = $scope.toDateOne;
                $scope.toDateOne = aux;
            }
            if ($scope.fromDateTwo > $scope.toDateTwo) {
                var aux = $scope.fromDateTwo;
                $scope.fromDateTwo = $scope.toDateTwo;
                $scope.toDateTwo = aux;
            }
            var params = '?fromDate_1=' + this.transformToRESTyDate($scope.fromDateOne);
            params += '&toDate_1=' + this.transformToRESTyDate($scope.toDateOne);
            params += '&fromDate_2=' + this.transformToRESTyDate($scope.fromDateTwo);
            params += '&toDate_2=' + this.transformToRESTyDate($scope.toDateTwo);
            params += '&rate=' + $scope.rate;
            return params;
        };

    }
]

export {SCDoubleReportCtrl};
